/* eslint-disable consistent-return */
import { URL } from "../constants/api-constants";

import { getIsAuthenticated, getSessionToken } from "../utils/user";

import http from "./http-common";

// Props for mfa check
// interface Props {
//   email: string;
//   code: string;
//   session: string;
// }

// Login for check mfa
// login: async ({ email, code, session }: Props) => {
//   try {
//     const response = await http.post(URL.CHECK_MFA_CODE, { email, code, session });
//     return await Promise.resolve(response);
//   } catch (error) {
//     return Promise.reject(error);
//   }
// },

interface Props {
  email: string;
  password_digest: string;
}

interface ErrorProps {
  status: number;
}

const authProvider = {
  login: async ({ email, password_digest }: Props) => {
    try {
      const response = await http.post(URL.SIGN_IN, { email, password_digest });
      return await Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async logout() {
    try {
      if (getSessionToken()) {
        await http.get(URL.SIGN_OUT);
      }
    } catch (error) {
      console.error(error);
    }
  },

  checkAuth: () => {
    const isAuth = getIsAuthenticated();
    if (isAuth) {
      return Promise.resolve();
    }
    return Promise.reject();
  },

  checkError: (error: ErrorProps) => {
    const { status } = error;
    console.error(error);
    if (status === 401 || status === 403) {
      return Promise.reject();
    }
    return Promise.resolve();
  },
};

export default authProvider;
